import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Chart, registerables } from 'chart.js';

@Component({
  selector: 'app-metrics-bar',
  templateUrl: './metrics-bar.component.html',
  styleUrls: ['./metrics-bar.component.scss'],
})
export class MetricsBarComponent implements OnInit, AfterViewInit {
  @ViewChild('lineCanvas') private lineCanvas: ElementRef;
  @Input() product: any;
  public lineChart: any;

  constructor(public modalController: ModalController) {
    Chart.register(...registerables);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.lineChartMethod();
  }

  lineChartMethod() {
    this.lineChart = new Chart(this.lineCanvas.nativeElement, {
      type: 'bar',
      data: {
        labels: ['Ventas', 'Vistas'],
        datasets: [
          {
            data: [this.product.sales, this.product.views],
            backgroundColor: `rgba(75,192,192,0.4)`,
            borderColor: 'rgba(75,192,192,1)',
            label: '',
          },
        ],
      },
    });
  }
}
